import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppStateService } from '../app-state.service';
import { StudijnyProgram } from '../model/studijny-program';
import { TranslateService } from '@ngx-translate/core';

export interface StudProgramyDialogData {
  idStudProgram: number;
  pocetSkopirovanychPoloziek: number;
}

export interface Jazyk {
  kod: string;
  oznaceny: boolean;
}

@Component({
    selector: 'app-studijne-programy-copying-dialog',
    templateUrl: './studijne-programy-copying-dialog.component.html',
    styleUrls: ['./studijne-programy-copying-dialog.component.css'],
    standalone: false
})
export class StudijneProgramyCopyingDialogComponent implements OnInit {

  idStudProgramIN: number;
  studProgramy = ['DMd - Diskrétna matematika', 'DMde – Diskrétna matematika'];
  studijneProgramyZRegistraPole: StudijnyProgram[] = [];
  skratkaOznacenyStudProgram: string;
  indexOznacenyStudProgram: number;
  zobrazitHelpText = false;
  searchedDataInput = '';
  oznacenieStudProgramovPole: boolean[] = [];
  indexyStudProgramov = [];
  // jazyky = ['SK', 'EN', 'FR'];
  jazykyZvolenehoStudProgramu: Jazyk[] = [];
  upozornenieText = '';

  studProgramyDotiahnute: boolean = null;

  disablovanyPotvrditButton = true;

  jazyky = {
    kod: '',
    oznaceny: false
  }

  checknuteJazykyZvolenehoStudProgramu = [];
  // pocetSkopirovanychPoloziek = 0;

  spinner = false;

  constructor(private appStateService: AppStateService,
    public dialogRef: MatDialogRef<StudijneProgramyCopyingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dataMatDialog: StudProgramyDialogData,
    private translateService: TranslateService) {

  }

  ngOnInit(): void {

    this.idStudProgramIN = this.dataMatDialog.idStudProgram;

    for (let i = 0; i < this.studProgramy.length; i++) {
      this.indexyStudProgramov[i] = false;
    }

  }


  onSubmit() {
  }

  getHelpTooltipText() {
    let result = this.translateService.instant('Zadajte časť skratky alebo názvu študijného programu (aj bez diakritiky).');
    if (this.appStateService.haikOdbor) {
      result = this.translateService.instant('Zadajte časť skratky alebo názvu odboru (aj bez diakritiky).');
    }
    return result;
  }

  getSearchedDataInputPlaceholder() {
    let result = this.translateService.instant('Študijný program');
    if (this.appStateService.haikOdbor) {
      result = this.translateService.instant('Odbor');
    }
    return result;
  }

  getZmazText() {
    return this.translateService.instant('Zmazať');
  }

  onStudProgramRadioBoxChange() {

    this.disablovanyPotvrditButton = true;

    this.jazykyZvolenehoStudProgramu = [];

    // console.log('index oznaceneho riadku: ' + this.indexOznacenyStudProgram);
    // console.log('Stud. program z registra (aktualne oznaceny): '
    //   + this.studijneProgramyZRegistraPole[this.indexOznacenyStudProgram].id);


    this.appStateService.fetchJazykyFormularaStudProgramu(
      this.studijneProgramyZRegistraPole[this.indexOznacenyStudProgram].id);

      this.appStateService.jazykyPoloziekDokumentuStudProgramuDataFetched
      .subscribe((jazykyData) => {

        if (jazykyData && jazykyData.length > 0) {
          for (let index = 0; index < jazykyData.length; index++) {
            const kodJazyk = jazykyData[index];
            const jazyk: Jazyk = {
              kod: kodJazyk,
              oznaceny: true
            }
            this.jazykyZvolenehoStudProgramu[index] = jazyk;
          } {

          }
          // this.jazykyZvolenehoStudProgramu = jazykyData;
          this.disablovanyPotvrditButton = false;
        } else {
          this.upozornenieText = this.translateService.instant('pre tento študijný program neboli nájdené žiadne položky');
        }


      });

    for (let index = 0; index < this.studijneProgramyZRegistraPole.length; index++) {
      if (index === this.indexOznacenyStudProgram) {
        this.oznacenieStudProgramovPole[index] = true;
      } else {
        this.oznacenieStudProgramovPole[index] = false;
      }

    }
    this.oznacenieStudProgramovPole[this.indexOznacenyStudProgram] = true;
  }

  vyhladajStudProgramy(hladanyRetazec: string, myFormInvalid?: boolean) {

    // console.log('myFormInvalid: ' + myFormInvalid);
    if (myFormInvalid) {
      return;
    }

    this.spinner = true;

    this.appStateService.fetchStudProgramyZRegistraData(hladanyRetazec);

    this.appStateService.studProgramyZRegistraDataFetched
    .subscribe((data) => {

      this.spinner = false;

      if (data && data.length > 0) {
        this.studijneProgramyZRegistraPole = data;
        this.studProgramyDotiahnute = true;
      } else {
        this.studProgramyDotiahnute = false;
        this.studijneProgramyZRegistraPole = [];
      }

    });


  }

  potvrditVyberProgramu() {

    // ak sme nic nevybrali
    if (!this.indexOznacenyStudProgram) {
      return;
    }

    this.jazykyZvolenehoStudProgramu.forEach(jazyk => {
      if (jazyk.oznaceny) {
        this.checknuteJazykyZvolenehoStudProgramu.push(jazyk.kod);
      }
    });

    // console.log('checknute jazyky: ' + this.checknuteJazykyZvolenehoStudProgramu);

    if (this.studijneProgramyZRegistraPole && this.studijneProgramyZRegistraPole[this.indexOznacenyStudProgram]) {
      this.appStateService.kopirujPolozkyZoStudProgramu(
        this.studijneProgramyZRegistraPole[this.indexOznacenyStudProgram].id,
        this.checknuteJazykyZvolenehoStudProgramu);
    }


  }

  getNazovDialogu() {
    let result = this.translateService.instant('Študijné programy');
    if (this.appStateService.haikOdbor) {
      result = this.translateService.instant('Odbory habilitačného a inauguračného konania');
    }

    return result;
  }

  // validation(event) {
  //   const text = document.getElementById('searchedDataInput');
  //   if ((text as any).value === '') {
  //     event.cancel = true;
  //     alert("Enter the username and password");
  //   }

  // }

  clearSearchInput($event: MouseEvent) {
    if ($event instanceof PointerEvent) {
      if ($event.pointerType === 'mouse') {
        this.searchedDataInput = '';
      }
    }
  }

  keyPressed() {
    this.searchedDataInput = '';
  }

  overitDisablovaniePotvrditButtonu() {

      if (this.studProgramyDotiahnute && this.indexOznacenyStudProgram) {
          for (const jazyk of this.jazykyZvolenehoStudProgramu) {
            if (jazyk.oznaceny) {
              this.disablovanyPotvrditButton = false;
              return;
            }
          }
          this.disablovanyPotvrditButton = true;
      }

  }

  getHladajTooltip() {
    return this.translateService.instant("Hľadaj");
  }

}
